module.exports = __webpack_public_path__ + "img/line.c4702426.jpg";